import * as Msal from "msal";

export default class AuthService {
  constructor() {
    this.applicationConfig = {
      auth: {
        clientId: process.env.VUE_APP_AZURE_CLIENT_ID,
        graphScopes: [
          "user.read"
        ],
        authority: "https://login.microsoftonline.com/common"
      }
    };
    this.app = new Msal.UserAgentApplication(this.applicationConfig);
  }

  login() {
    let loginRequest = {
      scopes: [
        "user.read"
      ] // optional Array<string>
    };
    return this.app.loginPopup(loginRequest).then(response => { // handle response
      if (this.app.getAccount()) {
        let tokenRequest = {
          scopes: [
            "user.read", "mail.send"
          ]
        };
        return this.app.acquireTokenSilent(tokenRequest).then(token => {
          return token;
        }).catch(err => {
          if (err.name === "InteractionRequiredAuthError") {
            return this.app.acquireTokenPopup(tokenRequest).then(token => {
              return token;
            });
          }
        });
      }
    }).catch(err => {
      return null;
    });
  }

  getToken() {
    return this.app.acquireTokenSilent(this.applicationConfig.auth.graphScopes).then((accessToken) => {
      return accessToken;
    }, (error) => {
      return this.app.acquireTokenPopup(this.applicationConfig.auth.graphScopes).then((accessToken) => {
        return accessToken;
      }, (err) => {
        console.error(err);
      });
    });
  }
}
